export default {"src":"/_next/static/media/cart-white-mobile.ee63377d.svg","height":40,"width":34};